import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    snapshot: [],
    LineChartSett: {
      width: 'auto',
      height: 500,
      is3D: true,
      colors: ['#085178', '#e80021', '#1b9e77', '#2c67a5'],
      curveType: 'none',
      isStacked: 'relative',
      vAxis: {
        maxAlternation: 4,
        minorGridlines: {
          count: 15
        },
        minValue: 0,
        slantedText: true,
        slantedTextAngle: 70,
        gridlines: {
          count: 15
        },
        textStyle: {
          fontSize: 12
        },
        format: 'short',
        viewWindowMode: 'pretty'
      },
      hAxis: {
        format: 'short',
        viewWindowMode: 'pretty',
        // format: 'MMM dd, yyyy',
        textStyle: {
          fontSize: 13
        },
        color: '#FF0000'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 16,
          isHtml: true
        },
        showColorCode: true
      },
      lineWidth: 2.3,
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#303133',
          fontSize: 14,
          bold: true
        }
      },
      chartArea: {
        left: '15%',
        top: '5%',
        width: '100%',
        height: '70%'
      }
    },
    date_range: []
  },

  mutations: {
    setSnapshot(state, payload) {
      state.snapshot = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setDateRange(state, payload) {
      state.date_range = [payload.start, payload.end]
    }
  },

  actions: {
    read({ commit }) {
      commit('setLoading', true)
      axios.api
        .get('report/count/channels', {})
        .then(r => {
          commit('setData', r.data.data.report)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readSnapshot({ commit, state }) {
      commit('setLoading', true)
      axios.api
        .get('report/snapshot', {
          params: {
            start: state.date_range[0],
            end: state.date_range[1]
          }
        })
        .then(r => {
          commit('setSnapshot', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    }
  },

  getters: {
    snapshot_artist: state => {
      let result = []
      for (let i = 0; i < state.snapshot.length; i++) {
        if (i === 0) {
          state.snapshot.map(s => {
            const date = new Date(s[0])
            result.push([date.toDateString().slice(3, 15), s[1]])
          })
        }
      }
      return result
    },
    snapshot_artist_daily: state => {
      let result = []
      for (let i = 0; i < state.snapshot.length; i++) {
        if (i === 0) {
          state.snapshot.map(s => {
            const date = new Date(s[0])
            result.push([date.toDateString().slice(3, 15), s[2]])
          })
        }
      }
      return result
    },
    snapshot_track: state => {
      let result = []
      for (let i = 0; i < state.snapshot.length; i++) {
        if (i === 0) {
          state.snapshot.map(s => {
            const date = new Date(s[0])
            result.push([date.toDateString().slice(3, 15), s[3]])
          })
        }
      }
      return result
    },
    snapshot_track_daily: state => {
      let result = []
      for (let i = 0; i < state.snapshot.length; i++) {
        if (i === 0) {
          state.snapshot.map(s => {
            const date = new Date(s[0])
            result.push([date.toDateString().slice(3, 15), s[4]])
          })
        }
      }
      return result
    },
    snapshot_subscribers: state => {
      let result = []
      for (let i = 0; i < state.snapshot.length; i++) {
        if (i === 0) {
          state.snapshot.map(s => {
            const date = new Date(s[0])
            result.push([date.toDateString().slice(3, 15), s[5]])
          })
        }
      }
      return result
    },
    snapshot_subscribers_daily: state => {
      let result = []
      for (let i = 0; i < state.snapshot.length; i++) {
        if (i === 0) {
          state.snapshot.map(s => {
            const date = new Date(s[0])
            result.push([date.toDateString().slice(3, 15), s[6]])
          })
        }
      }
      return result
    },
    snapshot_views: state => {
      let result = []
      for (let i = 0; i < state.snapshot.length; i++) {
        if (i === 0) {
          state.snapshot.map(s => {
            const date = new Date(s[0])
            result.push([date.toDateString().slice(3, 15), s[7]])
          })
        }
      }
      return result
    },
    snapshot_views_daily: state => {
      let result = []
      for (let i = 0; i < state.snapshot.length; i++) {
        if (i === 0) {
          state.snapshot.map(s => {
            const date = new Date(s[0])
            result.push([date.toDateString().slice(3, 15), s[8]])
          })
        }
      }
      return result
    },
    snapshot_videos: state => {
      let value = 0;

      let result = []
      for (let i = 0; i < state.snapshot.length; i++) {
        if (i === 0) {
          state.snapshot.map(s => {
            const date = new Date(s[0])
            result.push([date.toDateString().slice(3, 15), s[9]])

            if(value == 0 && s[9])
            {
              value = s[9];
            }
          })
        }
      }

      state.LineChartSett.vAxis.minValue = value;

      return result
    },
    snapshot_videos_daily: state => {
      let result = []
      for (let i = 0; i < state.snapshot.length; i++) {
        if (i === 0) {
          state.snapshot.map(s => {
            const date = new Date(s[0])
            result.push([date.toDateString().slice(3, 15), s[10]])
          })
        }
      }
      return result
    },
    snapshot_channels: state => {
      let result = []
      for (let i = 0; i < state.snapshot.length; i++) {
        if (i === 0) {
          state.snapshot.map(s => {
            const date = new Date(s[0])
            result.push([date.toDateString().slice(3, 15), s[11]])
          })
        }
      }
      return result
    },
    snapshot_channels_daily: state => {
      let result = []
      for (let i = 0; i < state.snapshot.length; i++) {
        if (i === 0) {
          state.snapshot.map(s => {
            const date = new Date(s[0])
            result.push([date.toDateString().slice(3, 15), s[12]])
          })
        }
      }
      return result
    }
  }
}
